<script>
import DocumentListComponent from './components/resources/DocumentListComponent.vue';
import AutoriryComponent from './components/resources/AutoriryComponent.vue';
import NewsComponent from './components/resources/NewsComponent.vue';
import ITCGridComponent from './components/resources/ITCGridComponent.vue';
import BoxIconGridComponent from './components/resources/BoxIconGridComponent.vue';
import MultiSliderComponent from './components/resources/MultiSliderComponent.vue';
import FrecuentAccessComponent from './components/resources/FrecuentAccessComponent.vue';
import GridLinkComponent from './components/resources/GridLinkComponent.vue';
import CardGridComponent from './components/resources/CardGridComponent.vue';
import NotificationModal from './components/resources/NotificationModal.vue';
import { frecuentes } from '@/constants/frecuentes.js';
import { institucionales } from '@/constants/institucionales.js';
import { consultas } from '@/constants/consultas.js';
import { otros } from '@/constants/otros.js';
import { accesos } from '@/constants/accesos.js';
import { niveles } from '@/constants/niveles.js';
import { obtenerForm } from './services/obtenerForm';

export default {
  name: 'HomeView',
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
    /* eslint-disable */
    NotificationModal
  },
  data() {
    return {
      site: 30,
      frecuentes: frecuentes,
      institucionales: institucionales,
      consultas: consultas,
      otros: otros,
      accesos: accesos,
      niveles: niveles,
      // modal props
      modalTitle: '',
      modalMessage: '',
      modalHtml: ''
    }
  },

  mounted() {
    document.title = process.env.VUE_APP_TITLE;

    const getInfo = async () => {
      const results = await obtenerForm();
      console.log(results);
    }
    try {
      getInfo();
    }
    catch (error) {
      console.log(error);
    }

    // Abrir el modal en cuanto arranca la página (con iframe de ejemplo)
    /*this.abrirModal(
      'Información Educativa',
      '',
      '<iframe src="http://educacion.sanjuan.edu.ar/mesj/Prensa/Notificaciones.aspx" width="100%" height="500" frameborder="0" allowfullscreen></iframe>'
    );*/
  },
  methods: {
    /**
     * Abre el modal de notificación pasando título y mensaje.
     * El componente NotificationModal expone un método `show()`
     * que se invoca a través de la referencia $refs.notify.
     */
    abrirModal(titulo, mensaje = '', html = '') {
      this.modalTitle = titulo;
      if (html) {
        // si recibimos html, lo usamos en el slot y limpiamos message
        this.modalHtml = html;
        this.modalMessage = '';
      } else {
        this.modalMessage = mensaje;
        this.modalHtml = '';
      }
      if (this.$refs.notify && this.$refs.notify.show) {
        this.$refs.notify.show();
      }
    }
  }
}
</script>

<style scoped>
  .row {
    margin-bottom: 1rem;
  }

  .row > .col-sm {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding-bottom: 2rem;
  }

  @media (max-width: 767.98px) {
    .row > .col-sm {
      flex: 0 0 100%;
      max-width: 100%;
      padding-bottom: 1rem;
    }
  }
</style>

<!-- push -->
<template>
  
  <ITCGridComponent :columnas="5" titulo="" :data="[
    {
      desc: null,
      icon: 'description',
      target: 'blank',
      title: 'Consulta de expedientes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent'
    },
    {
      desc: null,
      icon: 'question_answer',
      target: 'blank',
      title: 'Consultas y solicitudes',
      url: '?uid=CUMV-VIEW-FormComponent'
    },
    {
      desc: null,
      icon: 'find_in_page',
      target: 'blank',
      title: 'Turnos Educación',
      url: 'https://turnos.sanjuan.gob.ar/'
    },
    {
      desc: null,
      icon: 'pending_actions',
      target: 'blank',
      title: 'Correo Web',
      url: 'https://webmail.sanjuan.edu.ar/owa'
    },
    {
      desc: null,
      icon: 'description',
      target: 'blank',
      title: 'Mesa de Ayuda',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/MesadeAyuda.aspx' //https://educacion.sanjuan.gob.ar/?uid=frame-
    }
  ]" />
<section class="container mb-0 pb-0">
  <div class="row">
      <div class="col-lg-12">
      <div class="alert alert-warning fade show p-4">
        <div class="row">
          <div class="col-lg-5">
            <div class="btn-secondary text-bg-ptn-color-gsj-brand" style="width:100%;" target="_blank">
              <br>
              <center>
              <h5><strong class="text-ptn-color-gsj-2">¡Atención!</strong> Junta Electoral Gabinetes Interdisciplinarios:</h5>
              </center>
              <br><br>
            </div>
          </div>
          <div class="col-lg-7">
          <strong>Cronograma electoral.</strong>&nbsp;&nbsp;<br><br>
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/CronogramaJuntaElectoralGabinetes2027.pdf" class="btn btn-primary text-bg-ptn-color-gsj-brand" target="_blank">Ingresar para ver información completa.</a>
          <br>
          </div>
        </div>
      </div>
    </div>
  </div> 
  <div class="row">
      <div class="col-lg-12">
      <div class="alert alert-warning fade show p-4">
        <div class="row">
          <div class="col-lg-5">
            <div class="btn-secondary text-bg-ptn-color-gsj-brand" style="width:100%;" target="_blank">
              <br>
              <center>
              <h5><strong class="text-ptn-color-gsj-2">¡Atención!</strong> Junta Rama Primaria:</h5>
              </center>
              <br><br>
            </div>
          </div>
          <div class="col-lg-7">
          <strong>Exhibición de Listados Provisorios, Interinatos y Suplencias -  Supervisor General. </strong>&nbsp;&nbsp;<br>
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/202610_JCRP_ExhibicionListadosProvisorios.pdf" class="btn btn-primary text-bg-ptn-color-gsj-brand" target="_blank">Ingresar para ver información completa.</a>
          <br><br>
          <strong>Traslados Preferenciales y Ordinarios 2027. </strong>&nbsp;&nbsp;<br>
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/20260706_TrasladosPreferencialesyOrdinarios2027.pdf" class="btn btn-primary text-bg-ptn-color-gsj-brand" target="_blank">Ingresar para ver información completa.</a>
          <br>
          </div>
        </div>
      </div>
    </div>
  </div> 
  <div class="row">
      <div class="col-lg-12">
      <div class="alert alert-warning fade show p-4">
        <div class="row">
          <div class="col-lg-5">
            <div class="btn-secondary text-bg-ptn-color-gsj-brand" style="width:100%;" target="_blank">
              <br>
              <center>
              <h5><strong class="text-ptn-color-gsj-2">¡Atención!</strong> Gabinetes Técnicos Interdisciplinarios </h5>
              </center>
              <br>
            </div>
          </div>
          <div class="col-lg-7">
          <strong>Convoca a inscripción para Ingreso a la docencia e Interinatos y Suplencias 2027.</strong><br><br>
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/JGTI_InscripcionAnual2027.pdf" class="btn btn-primary text-bg-ptn-color-gsj-brand" target="_blank">Ingresar para ver información completa.</a>
          </div>
        </div>
      </div>
    </div>
  </div> 
</section>
<NotificationModal ref="notify" :title="modalTitle" size="modal-xl">
  <div>
    <h3>Hola</h3>
    <p>Este es <strong>contenido</strong> del slot.</p>
  </div>
</NotificationModal>
<!--
<section class="container d-flex flex-column align-items-center">
  <div class="container">
    <div class="row">
      <div class="col-sm">
        <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/estaticas/FomacionesyCertificados.html" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_FormacionesyCertificadosPrincipal.jpg" width="99%">
        </a>
      </div>
    </div>
  </div>
</section>
-->
<section class="container d-flex flex-column align-items-center">
    <div class="container"> 
    <div class="row">
      <div class="col-sm">
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/estaticas/ConcursoAscensoDocente.html" target="_blank">
            <img id="imgServicios11" src="@/assets/img/BN_ConcursodeAscenso2026.jpg" width="99%" >
          </a>
      </div>
      <div class="col-sm">
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/202611_SemanaEducacionPrimaria_Actividades.pdf" target="_blank">
            <img id="imgServicios11" src="@/assets/img/BN_SemanaEdPrimaria2026.jpg" width="99%" >
          </a>
      </div>
      <div class="col-sm">
          <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/Aprender2026.aspx" target="_blank">
            <img id="imgServicios11" src="@/assets/img/BT_OperativoAprender2026.jpg" width="99%" >
          </a>
      </div>
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/TitularizaciónDocenteRequisitos.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_TitularizacionDocente.jpg" width="99%">
        </a>
      </div>
      <div class="col-sm">
          <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/202610_LibretaDigital.pdf" target="_blank">
            <img id="imgServicios11" src="@/assets/img/BN_NotasOrientadorasLibretaDigital.jpg" width="99%" >
          </a>
      </div>
      <div class="col-sm">
        <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/estaticas/FomacionesyCertificados.html" target="_blank">
          <img id="imgServicios11" src="@/assets/img/Bn_FormacionesyCertificados2026.jpg" width="99%" >
        </a>
     </div> 
     <div class="col-sm">
        <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/2026_PlanFinEs_Secundario.pdf" target="_blank">
          <img id="imgServicios1" src="@/assets/img/Bn_PlanFINES.jpg" width="99%">
        </a>
      </div>
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/LinkClick.aspx?fileticket=0oj3me4UXxE%3d&tabid=74&mid=1290" target="_blank">
          <img id="imgServicios11" src="@/assets/img/BN_CalendarioEscolar2026.jpg" width="99%" >
        </a>
      </div> 
      <div class="col-sm">
        <a href="https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/BecasProgresar2026.pdf" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_AsesoramientoPrograsar2026.jpg" width="99%">
        </a>
      </div>
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/FortalecimientoEscolar.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BnFortalecimientoEscolarGratuito2026.jpg" width="99%">
        </a>
      </div>
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/Antecedentes.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_CertificadoAntecedentes2025.jpg" width="99%">
        </a>
      </div>
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/PlandeContingencia.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_PlanPContingencia2025.jpg" width="99%">
        </a>
    </div>
    <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/ComprendoyAprendo.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_ComprendoyAprendo2025.jpg" width="99%">
        </a>
      </div>
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/Transformaci%C3%B3nSecundaria.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_TransformarlaSecunaria2025.jpg" width="99%">
        </a>
      </div>  
      <div class="col-sm">
        <a href="https://educacion.sanjuan.edu.ar/mesj/Prensa/BibliotecadelMagisterio.aspx" target="_blank">
          <img id="imgServicios1" src="@/assets/img/BN_BibliotecaMagisterio2026.jpg" width="99%">
        </a>
      </div>
     
  </div>
  </div>
  </section>

   <BoxIconGridComponent :columnas=5 titulo="" :data="this.frecuentes" />

  <!--
<CardGridComponent columnas="4" titulo=""  :data="[
     {
       target: '_blank',
       title: '> EDUCACIÓN PRIVADA',
       url: 'http://educacion.sanjuan.edu.ar/mesj/Prensa/Privada.aspx'
     },
     {
       target: '_blank',
       title: '> GABINETES TÉCNICOS INTERDISCIPLINARIOS',
       url: 'http://educacion.sanjuan.edu.ar/mesj/Prensa/GabinetesTécnicosInterdisciplinarios.aspx'
     }
   ]" />
-->
  <BoxIconGridComponent :columnas=4 titulo="METODOLOGÍAS PARA TRÁMITES FRECUENTES" :data="this.accesos" />
  
  <CardGridComponent columnas="1" titulo="" :data="[
    {
      target: '_blank',
      title: 'LICITACIONES',
      url: 'https://licitaciones.sanjuan.gob.ar'
    }
  ]" />
  
  <NewsComponent titulo="Noticias" />
  <MultiSliderComponent titulo="" :elementos="1" :mostrar-titulo="false" :mostrar-bordes="false" :ajustar="false" :data="[
    { 
      desc: null,
      imagen: require('@/assets/img/Bn_RelevamientoAnual-2024.jpg'),
      target: 'blank',
      url: 'https://educacion.sanjuan.edu.ar/mesj/OficinasME/PlaneamientoEducativo.aspx',
    },
    {
      desc: null,
      imagen: require('@/assets/img/ME_Banner CarrerasNivSUP.jpg'),
      target: 'blank',
      url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/estaticas/InstitutosDocente.html',
    },
    {
      desc: null,
      imagen: require('@/assets/img/bannernuevo.jpg'),
      target: 'blank',
      url: 'https://educacion.sanjuan.edu.ar/mesj/PlaneamientoEducativo/Avales.aspx',
    },
    {
      desc: null,
      imagen: require('@/assets/img/Bn_DirEducacionSecundTecnica.jpg'),
      target: 'blank',
      url: 'https://etpsanjuan.com.ar/',
    },
    {
      desc: null,
      imagen: require('@/assets/img/Bn_JardinesMaternales_EduPrivada2025.jpg'),
      target: 'blank',
      url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/EduPrivada_JardinesMaternales2023.pdf',
    },
    {
      desc: null,
      imagen: require('@/assets/img/Bn_InstitutoSuperior_EduPrivada.jpg'),
      target: 'blank',
      url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/EduPrivada_InstitutoHabilitados2023.pdf',
    },
    {
      desc: null,
      imagen: require('@/assets/img/Bn_InstitutoNoformal_EduPrivada.jpg'),
      target: 'blank',
      url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/archivos/InstitutosPrivadaNoFormal.pdf',
    },
    
  ]" />

  <BoxIconGridComponent :columnas=6 titulo="Institucionales" :data="this.institucionales" />
  <BoxIconGridComponent :columnas=3 titulo="Consultas" :data="this.consultas" />
   <!-- <BoxIconGridComponent :columnas=4 titulo="Otros Accesos" :data="this.otros" /> -->

  <!-- Iframe de enlaces de interes -->
  <section class="container d-flex flex-column align-items-center">
    <h3 class="align-self-start">Enlaces de interés</h3>
    <iframe class="overflow-hidden" src="./bannereducacion/index.html"
      width="100%" height="200px"></iframe>
  </section>

  <AutoriryComponent :showProtocolo="false" :showLinks="true" :data="[
    {
      title: 'Silvia Fuentes',
      subtitle: 'Ministro de Educación',
      imagen: require('@/assets/img/mindeeduc.jpg'),
    },
  ]" />

  <!-- componente de modal reutilizable -->
  <NotificationModal ref="notify" :title="modalTitle" size="modal-xl">
    <div v-html="modalHtml || modalMessage"></div>
  </NotificationModal>
</template> 